import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import LoginLogoutApi from "../../api/LoginLogoutApi";
import { useAuth } from '../../AuthContext';
import { visiUserSession, setVisiUserSession, visiUserData } from '../../GeneralFunction';

export function Logout() {

  const navigate = useNavigate();
  const { setWebsiteListData } = useAuth();

  useEffect(() => {

    // a support session ends back in the Admin panel, and its audit row has to be closed
    const userData = visiUserData();
    if (userData && Number(userData.is_support) === 1) {
      const adminUrl = userData.return_admin_url || (process.env.REACT_APP_OLD_VISIOPT_BASE_URL + 'admin/index.php');
      LoginLogoutApi.supportlogout()
        .finally(() => {
          localStorage.removeItem('visiUserData');
          localStorage.removeItem('visiMemberData');
          window.location.href = adminUrl;
        });
      return;
    }

    LoginLogoutApi.logout()
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/login");
        }
      }
    })
    .then(data => {
      setWebsiteListData([]);
      let newPage = '';      
      if(visiUserSession().page === "/reviewing-test"){
        newPage = '/review-tests';
      }else if(visiUserSession().page === "/test-history-report"){
        newPage = '/test-history';
      }else if(visiUserSession().page.includes("/create-campaign")){
        newPage = '/manage-campaigns';
      }else if(visiUserSession().page.includes("/campaign-report")){
        newPage = '/campaign-reports';
      }else if(visiUserSession().page === "/create-heatmap" || visiUserSession().page.includes("/heatmap-view")){
        newPage = '/heat-maps';
      }else if(visiUserSession().page === "/create-scrollmap" || visiUserSession().page.includes("/scrollmap-view")){
        newPage = '/scroll-maps';
      }else if(visiUserSession().page === "/recording-setting" || visiUserSession().page === "/recordings-list" || visiUserSession().page === "/recording-view"){
        newPage = '/recordings';
      }else{
        newPage = visiUserSession().page;
      }
      setVisiUserSession('page', newPage);
      localStorage.removeItem('visiMemberData');
      localStorage.removeItem('visiUserData');
      localStorage.removeItem('selectedFilteredOptions');
      localStorage.removeItem('selectedTestHistoryColumns');
      localStorage.removeItem('visiTrafficTables');
      navigate("/login");
    })
    .catch(error => {
      console.error('Error:', error);
    });

  }, [navigate]);

  return (
    <>
    </>
  );
}